import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function ComparisonSection() {
  const {
    t
  } = useLanguage();
  const comparisons = [{
    feature: t('comp.f1.name'),
    metal: t('comp.f1.metal'),
    concrete: t('comp.f1.concrete')
  }, {
    feature: t('comp.f2.name'),
    metal: t('comp.f2.metal'),
    concrete: t('comp.f2.concrete')
  }, {
    feature: t('comp.f3.name'),
    metal: t('comp.f3.metal'),
    concrete: t('comp.f3.concrete')
  }, {
    feature: t('comp.f4.name'),
    metal: t('comp.f4.metal'),
    concrete: t('comp.f4.concrete')
  }, {
    feature: t('comp.f5.name'),
    metal: t('comp.f5.metal'),
    concrete: t('comp.f5.concrete')
  }, {
    feature: t('comp.f6.name'),
    metal: t('comp.f6.metal'),
    concrete: t('comp.f6.concrete')
  }, {
    feature: t('comp.f7.name'),
    metal: t('comp.f7.metal'),
    concrete: t('comp.f7.concrete')
  }];
  return <section className="w-full bg-navy-900 py-20 sm:py-28 border-y border-steel-dark/50" data-id="element-31">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <FadeIn data-id="element-33">
          <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-34">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-35">
              {t('comp.title')}
            </h2>
            <p className="text-xl text-gray-300" data-id="element-36">{t('comp.subtitle')}</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-37">
          <div className="hidden md:block overflow-hidden rounded-xl border border-steel-dark bg-navy-800/50 shadow-2xl" data-id="element-38">
            <table className="w-full text-left border-collapse" data-id="element-39">
              <thead data-id="element-40">
                <tr className="bg-navy-900 border-b border-steel-dark" data-id="element-41">
                  <th className="p-6 text-xl font-bold text-white w-1/4" data-id="element-42">
                    {t('comp.feature')}
                  </th>
                  <th className="p-6 text-xl font-bold text-amber w-3/8 border-l border-steel-dark/50" data-id="element-43">
                    {t('comp.metal')}
                  </th>
                  <th className="p-6 text-xl font-bold text-gray-400 w-3/8 border-l border-steel-dark/50" data-id="element-44">
                    {t('comp.concrete')}
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-45">
                {comparisons.map((item, index) => <tr key={index} className="border-b border-steel-dark/30 hover:bg-navy-800/80 transition-colors" data-id="element-46">
                    <td className="p-6 text-white font-semibold" data-id="element-47">
                      {item.feature}
                    </td>
                    <td className="p-6 border-l border-steel-dark/50" data-id="element-48">
                      <div className="flex items-start gap-3" data-id="element-49">
                        <CheckCircle2 className="w-6 h-6 text-amber flex-shrink-0 mt-0.5" data-id="element-50" />
                        <span className="text-gray-200" data-id="element-51">{item.metal}</span>
                      </div>
                    </td>
                    <td className="p-6 border-l border-steel-dark/50" data-id="element-52">
                      <div className="flex items-start gap-3" data-id="element-53">
                        <XCircle className="w-6 h-6 text-gray-500 flex-shrink-0 mt-0.5" data-id="element-54" />
                        <span className="text-gray-400" data-id="element-55">{item.concrete}</span>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <div className="md:hidden space-y-6" data-id="element-56">
            {comparisons.map((item, index) => <div key={index} className="bg-navy-800 border border-steel-dark rounded-lg p-6 shadow-lg" data-id="element-57">
                <h3 className="text-xl font-bold text-white mb-4 border-b border-steel-dark/50 pb-2" data-id="element-58">
                  {item.feature}
                </h3>

                <div className="space-y-4" data-id="element-59">
                  <div data-id="element-60">
                    <span className="text-sm font-bold text-amber uppercase tracking-wider mb-1 block" data-id="element-61">
                      {t('comp.metal')}
                    </span>
                    <div className="flex items-start gap-3" data-id="element-62">
                      <CheckCircle2 className="w-5 h-5 text-amber flex-shrink-0 mt-0.5" data-id="element-63" />
                      <span className="text-gray-200" data-id="element-64">{item.metal}</span>
                    </div>
                  </div>

                  <div data-id="element-65">
                    <span className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-1 block" data-id="element-66">
                      {t('comp.concrete')}
                    </span>
                    <div className="flex items-start gap-3" data-id="element-67">
                      <XCircle className="w-5 h-5 text-gray-500 flex-shrink-0 mt-0.5" data-id="element-68" />
                      <span className="text-gray-400" data-id="element-69">{item.concrete}</span>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}